import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutPixelParams, checkoutUrl, price } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';

/**
 * Always-visible purchase shortcut on small screens: appears after the hero
 * and hides over the offer section. Visibility uses IntersectionObserver, so
 * it never forces a synchronous reflow on scroll.
 */
export function StickyCta() {
  const [isPastHero, setIsPastHero] = useState(false);
  const [isOnOffer, setIsOnOffer] = useState(false);
  useEffect(() => {
    const hero = document.querySelector('header');
    const offer = document.getElementById('offer');
    const heroObserver = new IntersectionObserver(([entry]) => setIsPastHero(!entry.isIntersecting), {
      threshold: 0
    });
    if (hero) heroObserver.observe(hero);
    const offerObserver = new IntersectionObserver(([entry]) => setIsOnOffer(entry.isIntersecting), {
      threshold: 0
    });
    if (offer) offerObserver.observe(offer);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  const isVisible = isPastHero && !isOnOffer;
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-slate-800 bg-slate-900 px-4 py-3 shadow-lg transition-[opacity,transform] duration-200 ease-out sm:hidden [.chalk_&]:border-slate-200 [.chalk_&]:bg-white ${isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-219" data-mp="gvp2wbyjj0cy">
      <a href={checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', checkoutPixelParams)} className="flex w-full items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-orange-500 px-6 py-3.5 text-sm font-bold uppercase leading-none tracking-wide text-slate-950 transition-colors duration-150 ease-out hover:bg-orange-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500 min-[400px]:text-base" data-id="element-220" data-mp="lvbe6fut66j4">
        Get full access now — {price}
        <ArrowRightIcon className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" data-id="element-221" data-mp="10kqd8cr69z59" />
      </a>
    </div>;
}